import { logger as dashingUILogger } from '@dashhudson/dashing-ui/logger';
import isError from 'lodash/isError';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

function checkArguments(...args) {
  const message = args?.[0];
  const messageContext = args?.[1];
  const error = args?.[2];
  if (message && !isString(message)) {
    throw Error('logger message must be a string');
  }
  if (messageContext && (!isObject(messageContext) || isError(messageContext))) {
    throw Error('logger messageContext must be an object and not an error');
  }
  if (error && !isError(error)) {
    throw Error('logger error must be an Error instance');
  }
}

export const logger = {
  debug(message, messageContext, error) {
    checkArguments(...arguments);
    return dashingUILogger.debug(message, messageContext, error);
  },
  info(message, messageContext, error) {
    checkArguments(...arguments);
    return dashingUILogger.info(message, messageContext, error);
  },
  warn(message, messageContext, error) {
    checkArguments(...arguments);
    return dashingUILogger.warn(message, messageContext, error);
  },
  error(message, messageContext, error) {
    checkArguments(...arguments);
    return dashingUILogger.error(message, messageContext, error);
  },
};
